<template>
    <div id="app">
		<v-app>
			<HomeHeader></HomeHeader>
			<div id="router-view">
				<router-view></router-view>
			</div>
			<HomeFooter></HomeFooter>
		</v-app>
    </div>
</template>

<script>
import HomeHeader from './components/Header/HomeHeader.vue';
import HomeFooter from './components/Footer/HomeFooter.vue';
export default {
    name: "App",
    components: { HomeHeader, HomeFooter }
}
</script>

<style lang="scss">
@mixin mobile-small {
	@media only screen and (maxs-width: 600px) {
		@content;
	}
}
@mixin mobile {
	@media only screen and (max-width: 768px) {
		@content;
	}
}
@mixin mobile-big {
	@media only screen and (max-width: 889px) {
		@content;
	}
}

#app {
    font-family: 'Times New Roman', Times, serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #10424b;
    background-color: white;
	overflow-y: hidden;
}
</style>
